// Necessary imports
import React from "react";
import i4 from "../components/Styles/assets/Graphics/Spa.webp";

import PPC from "../components/Styles/assets/Graphics/PPC.webp";
import LocalSEO from "../components/Styles/assets/Graphics/LocalSEO.webp";
import Analytics from "../components/Styles/assets/Graphics/Analytics.webp";
import Marketing from "../components/Styles/assets/Graphics/Marketing.webp";
import Gallery from "../components/Styles/assets/Graphics/Gallery.webp";
import MobileFriendly from "../components/Styles/assets/Graphics/MobileFriendly.webp";
import ContentMarketing from "../components/Styles/assets/Graphics/ContentMarketing.webp";
import WordPress from "../components/Styles/assets/Graphics/WordPress.webp";
import Enrole from "../components/Styles/assets/Graphics/Enrole.webp";
import ParentPortal from "../components/Styles/assets/Graphics/ParentPortal.webp";

import { StyledHCard, StyledClient } from "../components/Styles";
import Consultation from "../components/Consultation";

const Cosmetic = () => {
  return (
    <StyledClient.Container>
      <StyledClient.Content>
        <StyledClient.ShapeTopLeft>
          <img src={i4} alt="Icon" />
        </StyledClient.ShapeTopLeft>
        <StyledClient.Title>
          <span>Edmonton Cosmetic Services</span>
          Custom IT Services for Beauty center
        </StyledClient.Title>

        <StyledClient.Description>
          Looking to grow your daycare business and stand out in the local
          market? With a professional, stylish website tailored to your needs,
          we can help establish your authority and credibility with parents in
          your area. Our expert team specializes in web design, local SEO, and
          digital marketing, ensuring your daycare gets noticed by the right
          audience. From creating a user-friendly platform to streamlining
          parent communications, we provide all the tools you need to attract
          new families and build trust. Reliable, innovative, and
          results-driven, we’re here to help your daycare thrive. Call us today
          for a free consultation and discover how we can take your business to
          the next level!
        </StyledClient.Description>
      </StyledClient.Content>

      <Consultation />

      <StyledClient.H3>Common Services For Cosmetic Center</StyledClient.H3>

      <StyledHCard.Container>
        <StyledHCard.SingleCard>
          <StyledHCard.IconContainer>
            <img src={WordPress} alt="Icon" />
          </StyledHCard.IconContainer>
          <StyledHCard.Content>
            <StyledHCard.Title>Custom WordPress Web Design</StyledHCard.Title>
            <StyledHCard.Description>
              Create a daycare website that captures your unique identity with
              custom designs tailored to attract parents and showcase your
              services.
            </StyledHCard.Description>
          </StyledHCard.Content>
        </StyledHCard.SingleCard>

        <StyledHCard.SingleCard>
          <StyledHCard.IconContainer>
            <img src={LocalSEO} alt="Icon" />
          </StyledHCard.IconContainer>
          <StyledHCard.Content>
            <StyledHCard.Title>
              Local SEO for Maximum Visibility
            </StyledHCard.Title>
            <StyledHCard.Description>
              Ensure your daycare appears at the top of local search results,
              making it easy for nearby parents to find and trust your business.
            </StyledHCard.Description>
          </StyledHCard.Content>
        </StyledHCard.SingleCard>

        <StyledHCard.SingleCard>
          <StyledHCard.IconContainer>
            <img src={Marketing} alt="Icon" />
          </StyledHCard.IconContainer>
          <StyledHCard.Content>
            <StyledHCard.Title>
              Social Media Marketing That Engages Parents
            </StyledHCard.Title>
            <StyledHCard.Description>
              Reach your audience on platforms they love, with targeted
              campaigns designed to build trust and grow enrollments.
            </StyledHCard.Description>
          </StyledHCard.Content>
        </StyledHCard.SingleCard>

        <StyledHCard.SingleCard>
          <StyledHCard.IconContainer>
            <img src={Enrole} alt="Icon" />
          </StyledHCard.IconContainer>
          <StyledHCard.Content>
            <StyledHCard.Title>
              Online Enrollment System Integration
            </StyledHCard.Title>
            <StyledHCard.Description>
              Simplify the registration process for parents with seamless online
              forms and systems designed specifically for daycares.
            </StyledHCard.Description>
          </StyledHCard.Content>
        </StyledHCard.SingleCard>

        <StyledHCard.SingleCard>
          <StyledHCard.IconContainer>
            <img src={ContentMarketing} alt="Icon" />
          </StyledHCard.IconContainer>
          <StyledHCard.Content>
            <StyledHCard.Title>
              Optimized Content Marketing for Your Daycare
            </StyledHCard.Title>
            <StyledHCard.Description>
              Tell your story and highlight your strengths with engaging,
              keyword-rich content that builds your reputation and increases
              inquiries.
            </StyledHCard.Description>
          </StyledHCard.Content>
        </StyledHCard.SingleCard>

        <StyledHCard.SingleCard>
          <StyledHCard.IconContainer>
            <img src={MobileFriendly} alt="Icon" />
          </StyledHCard.IconContainer>
          <StyledHCard.Content>
            <StyledHCard.Title>
              Mobile-Friendly Design for Busy Parents
            </StyledHCard.Title>
            <StyledHCard.Description>
              Ensure your website looks and works perfectly on all devices,
              catering to parents on the go.
            </StyledHCard.Description>
          </StyledHCard.Content>
        </StyledHCard.SingleCard>

        <StyledHCard.SingleCard>
          <StyledHCard.IconContainer>
            <img src={PPC} alt="Icon" />
          </StyledHCard.IconContainer>
          <StyledHCard.Content>
            <StyledHCard.Title>
              Pay-Per-Click Advertising for Quick Leads
            </StyledHCard.Title>
            <StyledHCard.Description>
              Drive immediate traffic and inquiries with tailored ad campaigns
              targeting parents actively searching for childcare options.
            </StyledHCard.Description>
          </StyledHCard.Content>
        </StyledHCard.SingleCard>

        <StyledHCard.SingleCard>
          <StyledHCard.IconContainer>
            <img src={Gallery} alt="Icon" />
          </StyledHCard.IconContainer>
          <StyledHCard.Content>
            <StyledHCard.Title>
              Photo and Video Galleries to Showcase Your Space
            </StyledHCard.Title>
            <StyledHCard.Description>
              Highlight your daycare’s facilities, activities, and atmosphere
              with stunning visuals that build trust and appeal.
            </StyledHCard.Description>
          </StyledHCard.Content>
        </StyledHCard.SingleCard>

        <StyledHCard.SingleCard>
          <StyledHCard.IconContainer>
            <img src={ParentPortal} alt="Icon" />
          </StyledHCard.IconContainer>
          <StyledHCard.Content>
            <StyledHCard.Title>
              Parent Portal Integration for Communication
            </StyledHCard.Title>
            <StyledHCard.Description>
              Offer a secure, user-friendly platform for parents to stay
              updated, manage payments, and receive real-time notifications.
            </StyledHCard.Description>
          </StyledHCard.Content>
        </StyledHCard.SingleCard>

        <StyledHCard.SingleCard>
          <StyledHCard.IconContainer>
            <img src={Analytics} alt="Icon" />
          </StyledHCard.IconContainer>
          <StyledHCard.Content>
            <StyledHCard.Title>
              Analytics and Reporting for Continuous Improvement
            </StyledHCard.Title>
            <StyledHCard.Description>
              Track your website and marketing performance with detailed
              insights, ensuring your daycare stays ahead in the competitive
              market.
            </StyledHCard.Description>
          </StyledHCard.Content>
        </StyledHCard.SingleCard>
      </StyledHCard.Container>

      <Consultation />
    </StyledClient.Container>
  );
};

export default Cosmetic;
